import api from './axiosInstance';

export const galleryApi = {
  listFolders: () => api.get('/gallery/folders'),

  createFolder: name => api.post('/gallery/folders', {name}),

  deleteFolder: id => api.delete(`/gallery/folders/${id}`),

  listImages: (folderId, params = {}) =>
    api.get(`/gallery/folders/${folderId}/images`, {params}),

  uploadImages: (folderId, imageAssets) => {
    const formData = new FormData();
    imageAssets.forEach(asset => {
      formData.append('images', {
        uri: asset.uri,
        type: asset.type || 'image/jpeg',
        name: asset.fileName || `image_${Date.now()}.jpg`,
      });
    });
    return api.post(`/gallery/folders/${folderId}/images`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    });
  },

  deleteImage: id => api.delete(`/gallery/images/${id}`),

  toggleFavorite: (id, isFavorite) =>
    api.put(`/gallery/images/${id}/favorite`, {isFavorite}),
};
